import React from 'react';
import styled from 'styled-components';
import dateformat from 'dateformat';

const Container = styled.span`
    white-space: nowrap;
`

export default ({date}) => (
  <Container>
    {dateformat(date, 'dd.mm.yyyy HH:MM')}
  </Container>
)